import { NavLink } from "react-router-dom";
import clsx from "clsx";
import { useAuth } from "../auth/AuthContext";

const Section = ({ title, children, collapsed }) => (
  <div className="mt-4">
    <div className="px-3 text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</div>
    <div className="mt-1">{children}</div>
  </div>
);

const Item = ({ to, label, icon = "•", open }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      clsx(
        "flex items-center gap-3 rounded-md px-3 py-2 mx-2 text-sm",
        isActive ? "bg-brand-50 text-brand-800" : "text-slate-700 hover:bg-slate-100"
      )
    }
  >
    <span className="w-5 text-center">{icon}</span>
    {open && <span>{label}</span>}
  </NavLink>
);

export default function Sidebar({ open }) {
  const { user } = useAuth();
  const isAdmin = user?.user_role === "admin";

  return (
    <aside
      className={clsx(
        "fixed top-12 bottom-0 border-r bg-white overflow-y-auto transition-all shadow-soft z-20",
        open ? "w-64" : "w-16"
      )}
    >
       {/* 🟦 Dashboard Section */}
      <Section title="">
        <Item
          to="/dashboard"
          label="Dashboard"
          open={open}
          icon="📊"
          activeColor="bg-blue-600 text-white hover:bg-blue-700"
        />
        <Item
          to="/dashboard/hierarchy"
          label="Site Overview"
          open={open}
          icon="🗼"
          activeColor="bg-blue-600 text-white hover:bg-blue-700"
        />
        <Item
          to="/dashboard/tracker-status"
          label="Tracker Status"
          open={open}
          icon="🧭"
          activeColor="bg-blue-600 text-white hover:bg-blue-700"
        />
      </Section>

      <Section title="MAINTENANCE">
        <Item to="/maintenance/reports" label="Reports" open={open} icon="📝" />
        <Item to="/maintenance/iec-pr-reports" label="IEC PR Reports" open={open} icon="📐" />
        <Item to="/maintenance/tracker-reports" label="Tracker Reports" open={open} icon="🧭" />
        <Item to="/maintenance/tickets" label="Maintenance Tickets" open={open} icon="🎫" />
        <Item to="/reports/inverter-availability" label="Inverter Availability" open={open} icon="✅" />
      </Section>

      {isAdmin && (
        <Section title="ADMIN">
          <Item to="/maintenance/sites" label="Site Configuration" open={open} icon="🏭" />
          <Item to="/maintenance/config" label="Gateway Provisioning" open={open} icon="🧩" />
          <Item to="/maintenance/signals" label="Signal Settings" open={open} icon="🔧" />
          <Item to="/maintenance/signal-match" label="Signal Match" open={open} icon="🔗" />
          <Item to="/admin/organizations" label="Organizations" open={open} icon="🏢" />
          <Item to="/admin/users" label="Users" open={open} icon="👥" />
          <Item to="/admin/org-sites" label="Org ↔ Sites" open={open} icon="🧭" />
          <Item to="/admin/user-sites" label="User ↔ Sites" open={open} icon="🗂️" />
        </Section>
      )}

      {isAdmin && (
        <Section title="DATA">
          <Item to="/data/maintenance" label="Data Maintenance" open={open} icon="🗄️" />
          <Item to="/data/modbus/mapping" label="Modbus mapping" open={open} icon="🧭" />
          <Item to="/data/modbus/status" label="Modbus status" open={open} icon="📡" />
          <Item to="/data/scada/analytics" label="Gateway Status" open={open} icon="📶" />
          <Item to="/data/import" label="Import / Export" open={open} icon="⬆️" />
        </Section>
      )}
    </aside>
  );
}
